/**
 * CardIcon — sanitized from `assets/newSvg/card.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function CardIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M22,10 L22,17 C22,18.6569 20.6569,20 19,20 L5,20 C3.34315,20 2,18.6569 2,17 L2,10 L22,10 Z M18,14 L15,14 C14.4477,14 14,14.4477 14,15 C14,15.5523 14.4477,16 15,16 L18,16 C18.5523,16 19,15.5523 19,15 C19,14.4477 18.5523,14 18,14 Z M19,4 C20.6569,4 22,5.34315 22,7 L22,8 L2,8 L2,7 C2,5.34315 3.34315,4 5,4 L19,4 Z"
        fill={color}
      />
    </Svg>
  );
}

export default CardIcon;
